import slice from './reducer'
import service from './messages.service'

export {
  handleNewThreadNotificationThunk,
  handleNewMessageNotificationThunk,
} from './reducer'
export * from './selectors'
export const {
  // QUERIES
  useGetMessagesQuery,
  useLazyGetMoreMessagesQuery,
  useGetMessageThreadQuery,
  useGetMessageQuery,
  useInitRealTimeMessagesQuery,

  // MUTATIONS
  useCreateThreadMutation,
  useAddMessageMutation,
  useArchiveOrUnarchiveThreadMutation,
  useSetResponsibleMutation,
  useMarkThreadAsAnsweredMutation,
} = service

export const { setSection } = slice.actions

export default slice.reducer
